import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import './index.css';
import App from './App';
import store from './store';
import theme from './styles/theme';
import { checkAuth } from './features/auth/authSlice';

// 檢查用戶是否已登入
store.dispatch(checkAuth());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <CssBaseline />
            <App />
          </LocalizationProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// 如果你想在本地環境中測試 Service Worker，
// 取消註釋以下內容。對於生產環境，建議始終啟用。
// Learn more about service workers: https://bit.ly/CRA-PWA
// if (process.env.NODE_ENV === 'production') {
//   const { serviceWorkerRegistration } = require('./serviceWorkerRegistration');
//   serviceWorkerRegistration.register();
// } 